__webpack_public_path__ = window.__APP_PUBLIC_PATH__; // eslint-disable-line